/**
 * @file This component is to show the license agreement page
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';
import 'antd/dist/antd.css';
import { Select, Button, Checkbox, Alert } from 'antd';
import './LicenseAgreePage.css';
import {
    WINDOWS,
    LINUX,
    M2021,
    M11_3_4_1,
    M11_3_4,
    M11_3_5,
    M11_3_5_1,
    M11_3_5_2,
    M11_3_6,
    M11_3_7,
    M11_3_8,
    M11_3_9,
    M11_3_10,
    M11_3_11,
    M11_3_12,
    M11_4_03,
    M11_4_06,
    M11_4_09,
    M11_4_12,
    M11_5_03,
    M2021_UPDATE1,
    M2021_UPDATE2,
    M2021_UPDATE3,
    CUSTOM_INSTALL,
    EXPRESS_INSTALL,
} from '../../../Utils/Constants';

const { Option } = Select;

const licenseAgreePage = (props) => {
    /**
     *
     * @param {String} useOs the Operating System that selected
     * @param {String} useVersion the Version that selected
     * @return {Boolean} true, show the mode dropdown;  false, do noe show it
     */
    let showMode = (useOs, useVersion) => {
        return (
            useOs === WINDOWS &&
            (useVersion === M2021 ||
                useVersion === M11_3_4 ||
                useVersion === M11_3_4_1 ||
                useVersion === M11_3_5 ||
                useVersion === M11_3_5_1 ||
                useVersion === M11_3_5_2 ||
                useVersion === M11_3_6 ||
                useVersion === M11_3_7 ||
                useVersion === M11_3_8 ||
                useVersion === M11_3_9 ||
                useVersion === M11_3_10 ||
                useVersion === M11_3_11 ||
                useVersion === M11_3_12 ||
                useVersion === M11_4_03 ||
                useVersion === M11_4_06 ||
                useVersion === M11_4_09 ||
                useVersion === M11_4_12 ||
                useVersion === M11_5_03)
        );
    };

    let modeSelection = showMode(props.useOs, props.useVersion) ? (
        <div className="inputBox">
            Choose Strategy One Installation Mode:
            <br />
            <Select
                style={{ width: 400 }}
                defaultValue={props.getOriginState('mode')}
                onChange={(value) => {
                    props.setOriginState('mode', value);
                }}
            >
                <Option value={CUSTOM_INSTALL}>Custom</Option>
                <Option value={EXPRESS_INSTALL}>Express</Option>
            </Select>
        </div>
    ) : null;

    let showFullReleaseWarning = (useVersion) => {
        return (
            useVersion === M11_3_4 ||
            useVersion === M11_3_4_1 ||
            useVersion === M11_3_5 ||
            useVersion === M11_3_5_1 ||
            useVersion === M11_3_5_2 ||
            useVersion === M11_3_6 ||
            useVersion === M11_3_7 ||
            useVersion === M11_3_8 ||
            useVersion === M11_3_9 ||
            useVersion === M11_3_10 ||
            useVersion === M11_3_11 ||
            useVersion === M11_3_12 ||
            useVersion === M11_4_03 ||
            useVersion === M11_4_06 ||
            useVersion === M11_4_09 ||
            useVersion === M11_4_12 ||
            useVersion === M11_5_03
        );
    };

    let fullReleaseWarningMsg = (
        <div>
            Beginning with 2021 Update 4, all Strategy One updates will be
            installed using a full platform installer. This is useful for large
            enterprise deployments that need to automate <b>only</b> fresh
            installations for a single or multiple machines.
        </div>
    );

    let fullReleaseWarning = showFullReleaseWarning(props.useVersion) ? (
        <Alert
            className="fullReleaseWarning"
            showIcon
            message={fullReleaseWarningMsg}
            type="warning"
        />
    ) : null;

    let res = (
        <div>
            <div className="licensePage">
                <Checkbox
                    className="license-agree-check-box"
                    onChange={(e) => {
                        props.setOriginState('agreeLicense', e.target.checked);
                    }}
                    checked={props.getOriginState('agreeLicense')}
                >
                    I've read and agree with{' '}
                    <a
                        href="https://www.microstrategy.com/us/legal-folder/legal-policies/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </a>
                </Checkbox>
                <div className="inputBoxesContainer">
                    <div className="operationSys">
                        Choose Targeted Operating System:
                        <br />
                        <Select
                            style={{ width: 400 }}
                            defaultValue={props.useOs}
                            onChange={(value) => {
                                props.setOriginState('operateSystem', value);
                            }}
                        >
                            <Option value={WINDOWS}>Windows</Option>
                            <Option value={LINUX}>Linux</Option>
                        </Select>
                    </div>
                    <div className="inputBox">
                        {' '}
                        Strategy One Platform Releases:
                        <br />
                        <Select
                            style={{ width: 400 }}
                            defaultValue={props.getOriginState(
                                'installVersion'
                            )}
                            onChange={(value) => {
                                props.setOriginState('installVersion', value);
                            }}
                        >
                            <Option value={M11_5_03}>
                                March 2025
                            </Option>
                            <Option value={M11_4_12}>
                                December 2024
                            </Option>
                            <Option value={M11_4_09}>
                                September 2024
                            </Option>
                            <Option value={M11_4_06}>
                                June 2024
                            </Option>
                            <Option value={M11_4_03}>
                                March 2024
                            </Option>
                            <Option value={M11_3_12}>
                                2021 Update 12 - Full Platform Release
                            </Option>
                            <Option value={M11_3_11}>
                                2021 Update 11 - Full Platform Release
                            </Option>
                            <Option value={M11_3_10}>
                                2021 Update 10 - Full Platform Release
                            </Option>
                            <Option value={M11_3_9}>
                                2021 Update 9 - Full Platform Release
                            </Option>
                             <Option value={M11_3_8}>
                                2021 Update 8 - Full Platform Release
                            </Option>
                            <Option value={M11_3_7}>
                                2021 Update 7 - Full Platform Release
                            </Option>
                            <Option value={M11_3_6}>
                                2021 Update 6 - Full Platform Release
                            </Option>
                            <Option value={M11_3_5_2}>
                                2021 Update 5.2 - Full Platform Release
                            </Option>
                            <Option value={M11_3_5_1}>
                                2021 Update 5.1 - Full Platform Release
                            </Option>
                            <Option value={M11_3_5}>
                                2021 Update 5 - Full Platform Release
                            </Option>
                            <Option value={M11_3_4_1}>
                                2021 Update 4.1 - Full Platform Release
                            </Option>
                            <Option value={M11_3_4}>
                                2021 Update 4 - Full Platform Release
                            </Option>
                            <Option value={M2021_UPDATE3}>2021 Update 3</Option>
                            <Option value={M2021_UPDATE2}>2021 Update 2</Option>
                            <Option value={M2021_UPDATE1}>2021 Update 1</Option>
                            <Option value={M2021}>2021</Option>
                        </Select>
                    </div>
                    {modeSelection}
                    {fullReleaseWarning}
                </div>
            </div>
            <div className="buttonBar">
                <div className="description">
                    You are creating a configuration file for
                    <img
                        src={
                            props.useOs === WINDOWS
                                ? require('../../../assets/Icons/Windows.png')
                                : require('../../../assets/Icons/Linux.png')
                        }
                        alt="Operating System"
                    />
                </div>
                <div className="buttons">
                    <Button
                        className="buttonNext"
                        type="primary"
                        onClick={() =>
                            props.setOriginState('initialPage', false)
                        }
                        disabled={!props.getOriginState('agreeLicense')}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </div>
    );

    return res;
};

export default licenseAgreePage;
